import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { DealsNag, EmbedModal, ExtensionLoadingModal, FeedbackModal } from 'src/components';
import { GetCompare, GetEmpty, GetReview, GetTopControls } from 'src/components/get';
import { useRedirectToUpperCase, useScrollToTop, useVendorDeals } from 'src/hooks';
import { getCartIdAtom, getStepAtom, showEmbedModalAtom, showFeedbackModalAtom } from 'src/store';

export const Get = () => {
  const [step, setStep] = useAtom(getStepAtom);
  const [cartId, setCartId] = useAtom(getCartIdAtom);
  const [showEmbedModal, setShowEmbedModal] = useAtom<boolean>(showEmbedModalAtom);
  const [showFeedbackModal, setShowFeedbackModal] = useAtom(showFeedbackModalAtom);

  const { cartId: cartIdParam } = useParams();
  const [searchParams] = useSearchParams();

  useScrollToTop();
  useRedirectToUpperCase({
    cartIdParam,
    setCartId,
    pathname: 'get',
  });
  useVendorDeals({ cartId: cartIdParam });

  useEffect(() => {
    if (!cartId) {
      setStep(1);
      return;
    } else if (cartId && !searchParams.has('split')) {
      setStep(2);
      return;
    } else if (cartId && searchParams.has('split')) {
      setStep(3);
      return;
    }
  }, [cartId, searchParams, setStep]);

  const handleFeedbackClose = () => {
    setShowFeedbackModal(false);
  };

  return (
    <>
      <GetTopControls />
      {!cartIdParam ? (
        <GetEmpty />
      ) : (
        <div style={{ minHeight: window.innerHeight - 300 }}>
          {cartId && step === 2 && <GetReview />}
          {cartId && step === 3 && <GetCompare />}
        </div>
      )}

      <FeedbackModal cartId={cartId} open={showFeedbackModal} onClose={handleFeedbackClose} />
      <ExtensionLoadingModal />
      <EmbedModal cartId={cartId} show={showEmbedModal} setShow={setShowEmbedModal} />
      <DealsNag source='nag-get' />
    </>
  );
};
